import React from 'react'

function ArticalListBanner() {
  return (
    <>
    <section className="banner_section-inner packagebnner position-relative">
    <picture className="position-relative">
        <source srcSet={"/img/baneer1719164625.jpg"} media="(max-width:576px)" type="image/jpg"/>
        <img src="/img/baneer1719164625.jpg" className="d-block w-100 banner_search" alt="banner" type="image/jpg" loading="lazy"/>
    </picture>
    <div className="banner_searchBox">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="headingBnner_inner">
                        <h1>Articles &amp; Tips</h1>
                    </div>
                </div>
            </div>
        </div>

    </div>
</section>
    </>
  )
}

export default ArticalListBanner;